import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router,NavigationEnd  } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {GoogleAnalyticsService} from '../google-analytics.service';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppHeaderComponent  {

  menuOpen: boolean;
  homePage: boolean;
  routeSubscribe: Subscription;
  public showSearchContainer: boolean;

  constructor(private router: Router, private location: Location, public gaService: GoogleAnalyticsService, private cdr: ChangeDetectorRef) {
    this.menuOpen = false;
    // Computed synchronously from the actual URL, matching whatever the server rendered
    // from the very first tick — starting from `false` and correcting it asynchronously
    // via NavigationEnd (the previous approach) created a brief client/server mismatch on
    // initial load that could trigger an SSR hydration mismatch on the @if(homePage)
    // block, discarding and rebuilding it.
    // Location, not router.url: until the first navigation finishes router.url is still
    // '/', and on lazy-loaded routes (e.g. /collaborators, /download) that gap is long
    // enough to render the tall home banner on a non-home page, shifting the layout and
    // breaking #fragment scrolling.
    this.homePage = this.isHomeUrl(this.location.path());

    this.routeSubscribe = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => {
      this.homePage = this.isHomeUrl(e.url);
      // This component is OnPush; a guarded route (e.g. the async security
      // guard on /search) can resolve NavigationEnd well after this
      // subscription's initial view was painted, and outside any DOM event
      // originating in this component's own template. Without marking for
      // check here, the corrected homePage value updates the model but never
      // repaints until an unrelated click (e.g. a header nav link) forces CD.
      this.cdr.markForCheck();
    });

  }

  private isHomeUrl(url: string): boolean {
    return url === '/' || url === '/#news';
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  toggleSearch(){
    this.showSearchContainer = !this.showSearchContainer;
  }

}
